import components from "@/library/templates/Simple/componentsLib";
import "@/assets/simple.scss";

const plugin = {
  install(Vue: any) {
    for (const prop in components) {
      if (components.hasOwnProperty(prop)) {
        const component = components[prop as keyof typeof components];
        Vue.component(component.name, component);
      }
    }
  },
};
export default plugin;
